import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import type { Site } from "~types/site.ts";
import type { VenueResponse } from "~types/venue.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption> & {
  seasonId?: string;
};

export const SelectVenue = ({ value, seasonId, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: VenueResponse) => {
    return (response?.data || []).map((x) => {
      const sites = x.site && response?.includes?.resources && response.includes.resources[x.site.resourceType];
      const site = sites && (sites[x.site.id] as Site);
      const label = `${x.nameLocal}${site ? ` (${site.nameLocal})` : ""}`;
      return { label, value: x.venueId };
    });
  };

  const url = seasonId ? `${sport}/o/${organizationId}/seasons/${seasonId}/venues` : `${sport}/o/${organizationId}/venues`;

  return (
    <InfinitySelect<VenueResponse>
      {...props}
      url={url}
      filterParameters={{ include: "sites" }}
      searchParameter="nameLocalContains"
      sortByFieldName="nameLocal"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.VENUE}
      permissionOperation={PermissionOperations.READ}
      resetOptionsDependencies={[seasonId]}
    />
  );
};
